<template>
    <base-layout pageTitle="Datenschutz">
    DATENSCHUTZ
    </base-layout>
</template>

<script>
export default {
  name: 'DatenschutzPage',
};
</script>

<style scoped>
/* Add any custom styles for Datenschutz here */
</style>